// https://www.vuemastery.com/courses/next-level-vue/mixins/
// HomeAnonymous, Blog and Lander components use this for common landing page functionality

// ads use URLs like 
// https://storycircle.co/lander/215/?utm_source=facebook&utm_campaign={{campaign.name}}&utm_medium={{adset.name}}&utm_content={{ad.name}}&utm_term={{site_source_name}}%2F{{placement}}

import { Vue, Watch, Prop } from 'vue-property-decorator';
import { Component, Mixin, Mixins } from 'vue-mixin-decorator'
import * as utils from '../utils';

@Mixin
export default class LanderMixin extends Vue {
  public utm_source: string = null      // e.g., facebook or gemini
  public utm_campaign: string = null    // e.g., SC2 / Landings / Champ / Lander 215
  public utm_medium: string = null      // e.g., 40-60 / MF / All / StoryTelling
  public utm_content: string = null     // e.g., 006/elderly-couple-close-bw (006 is the primary text # - https://docs.google.com/spreadsheets/d/16QWzVlt1-3Qr9paAg1FtVSq2bLmO_j9cCkM6aA-WVuk/edit#gid=928297299)
  public utm_term: string = null        // e.g., fb/Facebook_Desktop_Feed or fb/Facebook_Mobile_Feed

  public title: string = null
  public subtitle: string = null
  public signUpText: string = null
  public stepsType: string = 'simpleChampion'
  public image: string = null
  public buttonCTA: string = null
  public showFbComments: boolean = false
  public urgencyText: string = null
  public showSteps: boolean = false
  public showPricing: boolean = null
  public showQuiz: boolean = null
  public video: string = null

  public optimizeForFacebook(): boolean { return this.$fb.isLoggedIntoStoryCircleViaFacebook || (this.$fb.useFbLoginRandomAB && process.env.VUE_APP_FB_LOGIN === 'true' && this.$fb.isLoggedIntoFacebook && this.utm_source === 'facebook') }

  public setImageBasedOnUTMContent() {
    if (this.utm_content && this.image && this.image.endsWith('.jpg')) {
      if (this.utm_content.includes('pretty-woman-older-dad')) this.image = 'pretty-woman-older-dad-974x450-50.jpg';
      if (this.utm_content.includes('father-son')) this.image = 'father-son-1000x462-50.jpg';
      if (this.utm_content.includes('elderly-woman-red-hair-phone')) this.image = 'elderly-woman-red-hair-phone-750x500-50.jpg';
      if (this.utm_content.includes('elderly-couple-close-bw')) this.image = 'elderly-couple-close-bw-750x500-50.jpg';
      if (this.utm_content.includes('elderly-black-man-deep-thought')) this.image = 'elderly-black-man-deep-thought-885x500-50.jpg';
      if (this.utm_content.includes('smiling-granddaughter-grandmother-couch')) this.image = 'smiling-granddaughter-grandmother-couch-892x500-50.jpg';
      if (this.utm_content.includes('elderly-woman-cellular-phone')) this.image = 'elderly-woman-cellular-phone_739x500-50.jpg';
      if (this.utm_content.includes('senior-hispanic-man-straw-hat')) this.image = 'senior-hispanic-man-straw-hat_817x500-50.jpg';
      if (this.utm_content.includes('serious-senior-hispanic-man-glasses-hat')) this.image = 'serious-senior-hispanic-man-glasses-hat_749x500-50.jpg';
      if (this.utm_content.includes('grandma-granddaughter-sofa')) this.image = 'grandma-granddaughter-xmas-couch-tablet-1023x500x50.jpg';
      if (this.utm_content.includes('asian-grandfather-and-grandson')) this.image = 'asian-grandfather-and-grandson-1197x500-50.jpg';
      if (this.utm_content.includes('asian-santa-grandfather-and-grandson')) this.image = 'asian-santa-grandfather-and-grandson-1067x500-50.jpg';
      if (this.utm_content.includes('family-daughter-laptop')) this.image = 'family-daughter-laptop-964x450-50.jpg';
      if (this.utm_content.includes('grandparents-laughing-with-grandchildren')) this.image = 'grandparents-laughing-with-grandchildren-1000x489-50.jpg';
      
      if (this.utm_content.includes('video/elderly-couple-close-bw/6')) {
        // choose a random one from the video
        const images: string[] = [
          'elderly-couple-close-bw-750x500-50.jpg',
          'pretty-woman-older-dad-974x450-50.jpg',
          'grandma-granddaughter-xmas-couch-tablet-1023x500x50.jpg',
          'elderly-woman-red-hair-phone-750x500-50.jpg',
          'smiling-granddaughter-grandmother-couch-892x500-50.jpg',
          'senior-hispanic-man-straw-hat_817x500-50.jpg'
        ]
        this.image = images[Math.floor(Math.random() * images.length)]
      }
    }
    if (this.utm_content && this.image && this.image.startsWith('video/')) {
      if (this.utm_content.includes('video/toonly_alex')) this.image = 'video/toonly_alex';
      if (this.utm_content.includes('video/whiteboard_keymanj')) this.image = 'video/whiteboard_keymanj';
    }

  }

  // lifecycle hooks - these get run before the component's created and mounted, respectively
  public created() {
    if (this.$store.state.devmode) console.log('LanderMixin START created()', this.$route.query);
    utils.saveUTMsToLocalStorage(this.$route.query)

    this.utm_source = localStorage.getItem('utm_source')
    this.utm_campaign = localStorage.getItem('utm_campaign')
    this.utm_medium = localStorage.getItem('utm_medium')
    this.utm_content = localStorage.getItem('utm_content')
    this.utm_term = localStorage.getItem('utm_term')

    // randomly choose if we show fb comments (we'll track if it's better or not in Amplitude)
    // TODO: compare for home, blog and lander and change accordingly
    //  02/19/2020: 
    //    home: true was 17.1% and false was 0% after 70 impressions
    //    blog: true was 3.33% and false was 2.86% after 65 impressions
    //    lander: equal after about 1100 impressions
    // Update: changed to be always true
    if (Math.random() < 1 && this.utm_source === 'facebook') this.showFbComments = true; else this.showFbComments = false;

    // show quiz 50% of the time when user is on homepage and came directly from an ad
    // Update: changed to be always false
    if (Math.random() < 0.0 && this.$route.query && this.$route.query.utm_source && this.$options.name === 'HomeAnonymous') this.showQuiz = true; else this.showQuiz = false;

    // to show the right kinds of steps
    if (this.utm_campaign && this.utm_campaign.includes('champ')) this.stepsType = 'simpleChampion'
    if (this.utm_campaign && this.utm_campaign.includes('listener')) this.stepsType = 'simpleChampion'
    if (this.utm_campaign && this.utm_campaign.includes('elderly')) this.stepsType = 'simpleStoryteller'
    if (this.utm_campaign && this.utm_campaign.includes('storyteller')) this.stepsType = 'simpleStoryteller'

    // show steps only for Blog
    if (this.$options.name === 'HomeAnonymous') this.showSteps = false
    if (this.$options.name === 'Blog') this.showSteps = true
    if (this.$options.name === 'Lander') this.showSteps = false

    // for now, only the home page shows a video button, so choose video randomly and track it
    if (this.$options.name === 'HomeAnonymous') {
      if (Math.random() < 0.5) this.video = 'whiteboard_keymanj'; else this.video = 'champ_powerdesign'
    }

  }

  public mounted() {
    if (this.$store.state.devmode) console.log('LanderMixin mounted()');

    const trackProps: any = {
      landingPageType: this.$options.name,
      landingPageImage: this.image,
      landingPageTitle: this.title,
      landingPageSubtitle: this.subtitle,
      landingPageButtonCTA: this.buttonCTA,
      landingPageSignUpText: this.signUpText,
      landingPageStepsType: this.stepsType,
      landingPageShowFbComments: this.showFbComments,
      landingPageUrgencyText: this.urgencyText,
      landingPageShowSteps: this.showSteps,
      showFBLogin: this.$fb.useFbLoginRandomAB,
      showPricing: this.showPricing,
      showQuiz: this.showQuiz,
      video: this.video
    }

    if (this.$store.state.devmode) console.log('FirstPage Viewed', trackProps);
    
    (window as any).analytics.track('FirstPage Viewed', trackProps);

    // show Quiz
    if (this.showQuiz) this.$store.commit('setInQuiz', { inQuiz: true });

  }
}
